import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * The `text-[11px] font-bold uppercase tracking-widest text-ink-subtle`
 * eyebrow label pattern used above list sections (Dashboard "Trips · N",
 * "Invited · N", Profile "Appearance", Profile "Account", etc). One place
 * to change the token, one class list to remember.
 */
interface OverlineProps {
  children: ReactNode;
  className?: string;
  /** Renders as the given element instead of the default `<p>`. */
  as?: "p" | "span" | "h2" | "h3";
}

export function Overline({ children, className, as: Tag = "p" }: OverlineProps) {
  return (
    <Tag
      className={cn(
        "m-0 text-[11px] font-bold uppercase tracking-widest text-ink-subtle",
        className,
      )}
    >
      {children}
    </Tag>
  );
}
